import { render, staticRenderFns } from "./TargaTelematics.vue?vue&type=template&id=6a3b5f5a&scoped=true"
import script from "./TargaTelematics.vue?vue&type=script&lang=js"
export * from "./TargaTelematics.vue?vue&type=script&lang=js"
import style0 from "./TargaTelematics.vue?vue&type=style&index=0&id=6a3b5f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b5f5a",
  null
  
)

export default component.exports